module.exports = __webpack_public_path__ + "img/如何美化画布.c4e3f676.gif";